const site = { siteId: 'admin', adminId: 'admin', siteName: 'ADMIN', partnerType: 'site', recommenderId: '', creditRate: 100 }
const day = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul' }).format(new Date())
const groups = [{ code: 'casino', codeName: '카지노', groupCode: 'casino', groupCodeName: '카지노' }, { code: 'slot', codeName: '슬롯', groupCode: 'slot', groupCodeName: '슬롯' }]
const games = [{ code: '1', codeName: '샘플 카지노', groupCode: 'casino', useYn: 'Y' }, { code: '200', codeName: '샘플 슬롯', groupCode: 'slot', useYn: 'Y' }]
const members = Array.from({ length: 35 }, (_, i) => ({
  memId: `admin${String(i + 1).padStart(3, '0')}`, memNick: `샘플회원${i + 1}`, memName: `가상회원${i + 1}`,
  siteId: 'admin', memLevel: String(i % 3 + 1), partnerLevel: 'NORMAL', partnerLevelName: '회원',
  memDelYn: 'N', memBlackYn: 'N', memLockYn: 'N', loginYn: 'Y', betYn: 'Y', recommendYn: 'Y',
  memStatus: '1', cashAmt: 150000 + i * 10000, pointAmt: 2500 + i * 100, gameMoney: 0,
  totalCashInAmt: 500000 + i * 10000, totalCashOutAmt: 200000, totalCashDiff: 300000 + i * 10000,
  totalWlAmt: -15000, casinoWlAmt: -10000, slotWlAmt: -5000, eSportsWlAmt: 0, mgWlAmt: 0, sportsWlAmt: 0, kgWlAmt: 0,
  recommenderId: 'samplePartner', recommenderNick: '샘플파트너', totalLoginCount: i + 2, totalBonusAmt: 10000,
  topUserList: [{ memId: 'samplePartner', memNick: '샘플파트너', partnerLevelName: '총판' }],
  regDt: `${day} 09:00:00`, lastLoginDt: `${day} 10:${String(i % 60).padStart(2, '0')}:00`,
  loginIp: '192.0.2.1', memPhone: '샘플 / 미제공', bank: '샘플은행', bankacc: '가상 계좌', memo: '실제 회원이 아닌 체험용 데이터입니다.'
}))
const bets = Array.from({ length: 60 }, (_, i) => {
  const win = i % 3 !== 0
  return {
    memId: members[i % members.length].memId, betIdx: i + 1, betId: `ADMIN-BET-${i + 1}`,
    gameCategory: i % 2 ? 'slot' : 'casino', vendorCode: i % 2 ? '200' : '1', vendorName: '샘플 공급사',
    gameName: i % 2 ? '샘플 슬롯' : '샘플 바카라', gameType: i % 2 ? '200' : '1', betType: 'kplay',
    type: win ? 'win' : 'lose', betStatus: 'DONE', betAmt: 10000, betWinAmt: win ? 19000 : 0,
    bfMoney: 150000, afMoney: win ? 159000 : 140000, isBlankSpinYn: 'N', regDate: `${day} 10:${String(i % 60).padStart(2, '0')}:00`
  }
})
const menuList = []
function registerMenus(routes) {
  menuList.length = 0
  function visit(route) {
    if (route.meta && route.meta.code && !menuList.some(m => m.menuCode === route.meta.code)) {
      menuList.push({ menuCode: route.meta.code, menuCodeName: route.meta.text, menuCodeNameEN: route.meta.text, useYn: 'Y' })
    }
    for (const child of route.children || []) visit(child)
  }
  for (const route of routes) {
    visit(route)
  }
}
function filtered(rows, params, dateKey) {
  return rows.filter(row => {
    for (const key of ['memId', 'memNick', 'memName', 'recommenderId', 'betId']) {
      if (params[key] && !String(row[key] || '').toLowerCase().includes(String(params[key]).toLowerCase())) return false
    }
    for (const key of ['memLevel', 'memBlackYn', 'memLockYn', 'memDelYn', 'loginYn', 'betYn', 'gameCategory', 'vendorCode']) {
      if (params[key] && params[key] !== 'all' && String(row[key]) !== String(params[key])) return false
    }
    if (dateKey && row[dateKey]) {
      const date = row[dateKey].slice(0, 10)
      if (params.startDate && date < params.startDate.slice(0, 10)) return false
      if (params.endDate && date > params.endDate.slice(0, 10)) return false
    }
    return true
  }).sort((a, b) => {
    const key = params.orderColumn || dateKey || 'memId'
    return String(a[key]).localeCompare(String(b[key]), undefined, { numeric: true }) * (params.orderType === 'ASC' ? 1 : -1)
  })
}
function page(rows, params) {
  const limit = Math.max(1, Math.min(100, Number(params.count_per_list) || 30))
  const current = Math.max(1, Math.min(Math.ceil(rows.length / limit) || 1, Number(params.page) || 1))
  return { list: rows.slice((current - 1) * limit, current * limit), pageInfo: { page: current, count_per_list: limit, limit, offset: (current - 1) * limit, tatal_list_count: rows.length, tatal_page_count: Math.ceil(rows.length / limit) } }
}
function token() {
  return `demo.${btoa(JSON.stringify({ exp: Math.floor(Date.now() / 1000) + 43200, sid: 'admin' }))}.demo`
}
function report(member) {
  const row = { ...member, cntBottom: 0, cntPartner: 0, botCashAmt: 0, botPointAmt: 0, userCashIn: member.totalCashInAmt, userCashOut: member.totalCashOutAmt, userCashResultAmt: member.totalCashDiff, partnerResultAmt: 0, adminResultAmt: 0, userPayment: 0, userPayback: 0, adminPayment: 0, adminPayback: 0, dcouponCash: 0, losingAmt: 0 }
  let betAmt = 0, betAmtWin = 0, rollingAmt = 0
  for (const group of ['casino', 'slot', 'mini', 'sport']) {
    const entries = bets.filter(b => b.memId === member.memId && b.gameCategory === group)
    const amount = entries.reduce((sum, b) => sum + b.betAmt, 0)
    const win = entries.reduce((sum, b) => sum + b.betWinAmt, 0)
    Object.assign(row, { [group + 'Rate']: 1, [group + 'LoseRate']: 0, [group + 'BetAmt']: amount, [group + 'BetAmtWin']: win, [group + 'BetResultAmt']: amount - win, [group + 'RollingAmt']: amount / 100, [group + 'LosingAmt']: 0, [group + 'BetAmtBS']: 0, [group + 'BetAmtWinBS']: 0, [group + 'BetResultAmtBS']: 0 })
    betAmt += amount
    betAmtWin += win
    rollingAmt += amount / 100
  }
  return { ...row, betAmt, betAmtWin, betResultAmt: betAmt - betAmtWin, rollingAmt, betAmtBS: 0, betAmtWinBS: 0, betResultAmtBS: 0 }
}
const totals = { cashAmt: members.reduce((sum, m) => sum + m.cashAmt, 0), pointAmt: members.reduce((sum, m) => sum + m.pointAmt, 0), memCnt: members.length, memLoginCnt: 3, memJoinCnt: 35, betMemCnt: 35, inCashAmt: members.reduce((sum, m) => sum + m.totalCashInAmt, 0), outCashAmt: 7000000, inCashCnt: 35, outCashCnt: 35, betAmt: 600000, winAmt: 760000, beneAmt: -160000, rollingAmt: 6000, adminPayment: 0, adminPayback: 0, adminPointIn: 0, adminPointOut: 0 }
const success = data => ({ resultCode: '0', resultMessage: 'SUCC', data })
function demoResponse(url, params = {}) {
  switch (url) {
    case '/api/admin/login': return params.siteId === 'admin' && params.sitePass === '1234' ? success({ token: token(), site, useOtp: 'N' }) : { resultCode: 'DEMO_LOGIN', resultMessage: '아이디 admin / 비밀번호 1234를 입력해주세요.' }
    case '/api/admin/getToken': return success({ token: token() })
    case '/api/admin/getMenuList': return success({ menuList })
    case '/api/admin/gameCodes': return success({ codes: games })
    case '/api/admin/gameGroupCodes': return success({ groupCodes: groups })
    case '/api/common/code': return success({ codes: params.masterCode === 'gameGroup' ? groups : params.masterCode === 'memLevel' ? [1, 2, 3].map(n => ({ code: String(n), codeName: `${n}등급` })) : games })
    case '/api/admin/getVendorList': return success({ vendorList: games })
    case '/api/admin/setting/option': return success({ option: {} })
    case '/api/admin/partner/detail': return success({ memberDetail: { ...site, memId: 'admin', memName: 'ADMIN', partnerType: 'site' } })
    case '/api/admin/headTopInfo': return success({ headTopInfo: totals })
    case '/api/admin/headCashInfo': return success({ headCashInfo: { creditAmt: 10000000, creditSubPoint: 0, siteCheckYn: 'N', cashInReqCnt: 0, cashInWaitCnt: 0, cashOutReqCnt: 0, cashOutWaitCnt: 0, memJoinReqCnt: 0, memJoinWaitCnt: 0, qnaReqCnt: 0, qnaWaitCnt: 0, creditCnt: 0, creditExchangeCnt: 0 } })
    case '/api/admin/headCreditInfo': return success({ creditAmt: 10000000, creditPointAmt: 0 })
    case '/api/admin/headMaxWinInfo': return success({ headMaxWinInfo: { maxWinAmt: 19000 }, maxWinAmt: 19000 })
    case '/api/admin/month10Info': return success({ month10Info: { userCashIN: totals.inCashAmt, userCashBEP: totals.inCashAmt - totals.outCashAmt, betBEP: totals.beneAmt } })
    case '/api/admin/top15Info': return success({ topList: [] })
    case '/api/admin/getMenuBookmarkList': return success({ menuBookmarkList: [] })
    case '/api/admin/getSiteMemo': return success({ memoInfo: { siteMemo: '포트폴리오 체험용입니다. 실제 저장은 하지 않습니다.' } })
    case '/api/admin/member/memberList': {
      const rows = filtered(members, params, 'regDt')
      return success({ ...page(rows, params), totalInfo: { totalCnt: rows.length, normalCnt: rows.length, partnerCnt: 0, yBetCnt: rows.length, yRecommendCnt: rows.length, yLoginCnt: rows.length } })
    }
    case '/api/admin/bet/betlist': return success(page(filtered(bets, params, 'regDate'), params))
    case '/api/admin/report/reportByUser': {
      const rows = filtered(members, params, 'regDt').map(report)
      const sum = {}
      for (const row of rows) for (const key in row) if (typeof row[key] === 'number') sum[key] = (sum[key] || 0) + row[key]
      sum.cntBottom = rows.length
      return success({ searchList: rows, searchTotal: sum, pageInfo: page(rows, params).pageInfo })
    }
    default: return { resultCode: 'DEMO_DISABLED', resultMessage: '데모에서는 이 기능을 실행하지 않습니다. 실제 데이터는 변경되지 않습니다.', data: {} }
  }
}
async function demoAdapter(config) {
  const params = typeof config.data === 'string' ? JSON.parse(config.data || '{}') : config.data || {}
  return { status: 200, statusText: 'OK', headers: {}, config, data: JSON.parse(JSON.stringify(demoResponse(config.url, params))) }
}
module.exports = { demoAdapter, demoResponse, members, bets, totals, menuList, registerMenus }
